define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    function until(predicate, interval) {
        if (interval === void 0) { interval = 200; }
        var result = $.Deferred();
        var timeout = setInterval(function () {
            if (predicate()) {
                clearInterval(timeout);
                result.resolve(true);
            }
        }, interval);
        return result.promise();
    }
    exports["default"] = until;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/until.js
// module id = 61
// module chunks = 0